import { css } from '@emotion/react';
import colors from 'config/color';

export const cardStyles = css`
  margin: 0 0 20px;
  display: flex;
  height: unset;
  flex-direction: column;
`;

export const topContainerStyles = css`
  display: flex;
  justify-content: space-between;
  padding: 20px 30px;
  width: calc(100% - 60px);

  button {
    background: ${colors.TRANSPARENT};
    border: none;
    width: fit-content;
    padding: 0;
  }

  span {
    font-size: 18px;
    font-weight: 600;
    line-height: 22px;
  }

  i {
    font-size: 20px;
    color: ${colors.BLUE};
  }
`;

export const horizontalLineStyles = css`
  background: ${colors.GRAY_LIGHT};
  width: 100%;
  height: 1px;
`;

export const attestationSectionContainerStyles = css`
  display: flex;
  flex-direction: column;
`;

export const buttonIconStyles = css`
  padding: 0;
  background: ${colors.TRANSPARENT};
  border: none;
`;

export const oneAttestationSectionContainerStyles = css`
  display: flex;
  flex-direction: column;
  padding: 30px;
  width: calc(100%- 60px);
  border-bottom: 1px solid ${colors.BORDER_BOTTOM_GREY};
`;

export const firstLineContainerStyles = css`
  display: flex;
  justify-content: space-between;

  i {
    color: ${colors.GREY};
  }
`;

export const dateStyles = css`
  font-size: 16px;
  font-weight: 600;
  line-height: 18px;
  color: ${colors.BLUE};
`;

export const attestationTypeStyles = css`
  color: ${colors.GRAY};
  margin: 5px 0 10px;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
`;

export const majorTextStyles = css`
  font-size: 15px;
  font-weight: 600;
  line-height: 18px;
  color: ${colors.SECONDARY_BLACK};
  margin: 0 0 5px;
`;

export const linkStyles = css`
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.01em;
  width: 95%;
  margin: 0 0 8px;
  text-transform: none;
`;
